export interface AnimeItem {
  id: string;
  title: string;
  studio: string;
  genre: string[];
  airTime: string;
  day: string;
  episode: string;
  desc: string;
  image: string;
}

export interface UpdateItem {
  id: string;
  title: string;
  episode: string;
  time: string;
  status: string;
}

export interface ClassicItem {
  id: string;
  title: string;
  year: string;
  episodes: string;
  score: string;
  tag: string;
  desc: string;
  image: string;
}

export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const scheduleDays = [
  { key: "monday", label: "周一" },
  { key: "tuesday", label: "周二" },
  { key: "wednesday", label: "周三" },
  { key: "thursday", label: "周四" },
  { key: "friday", label: "周五" },
  { key: "saturday", label: "周六" },
  { key: "sunday", label: "周日" },
];

export const scheduleData: AnimeItem[] = [
  {
    id: "s01",
    title: "星穹列车",
    studio: "灵犀动画",
    genre: ["冒险", "科幻"],
    airTime: "18:00",
    day: "monday",
    episode: "第8集",
    desc: "少年踏上横跨星海的列车，在星球间寻找失落的文明。",
    image: "https://readdy.ai/api/search-image?query=stylized%20anime%20artwork%20of%20a%20futuristic%20space%20train%20with%20warm%20coral%20glow%2C%20young%20boy%20hero%20standing%20in%20front%2C%20vibrant%20stars%20and%20nebula%20background%2C%20clean%20vector%20style&width=640&height=760&seq=anime-s01&orientation=portrait",
  },
  {
    id: "s02",
    title: "剑与铃音",
    studio: "岚山映画",
    genre: ["奇幻", "战斗"],
    airTime: "20:00",
    day: "monday",
    episode: "第8集",
    desc: "剑客少女与风之精灵的宿命之战，铃音响起即是决战之时。",
    image: "https://readdy.ai/api/search-image?query=stylized%20anime%20artwork%20of%20a%20female%20sword%20fighter%20with%20long%20teal%20hair%20holding%20a%20glowing%20blade%2C%20warm%20sunset%20background%2C%20fantasy%20battle%20scene%2C%20clean%20vector&width=640&height=760&seq=anime-s02&orientation=portrait",
  },
  {
    id: "s03",
    title: "云端邮局",
    studio: "青柠工作室",
    genre: ["治愈", "日常"],
    airTime: "22:00",
    day: "tuesday",
    episode: "第7集",
    desc: "住在云端小邮局的少年，为每一封思念找到它的归宿。",
    image: "https://readdy.ai/api/search-image?query=soft%20stylized%20anime%20artwork%20of%20a%20cozy%20floating%20post%20office%20in%20the%20clouds%2C%20warm%20pastel%20coral%20and%20amber%20tones%2C%20gentle%20healing%20atmosphere&width=640&height=760&seq=anime-s03&orientation=portrait",
  },
  {
    id: "s04",
    title: "都市怪谈夜话",
    studio: "夜猫动画",
    genre: ["悬疑", "奇幻"],
    airTime: "23:30",
    day: "tuesday",
    episode: "第7集",
    desc: "深夜电台里的怪谈栏目，每一段都市传说都有不为人知的真相。",
    image: "https://readdy.ai/api/search-image?query=stylized%20anime%20artwork%20of%20a%20mysterious%20night%20radio%20studio%20with%20teal%20and%20coral%20neon%20lights%2C%20urban%20mystery%20atmosphere%2C%20clean%20vector&width=640&height=760&seq=anime-s04&orientation=portrait",
  },
  {
    id: "s05",
    title: "青春排球部",
    studio: "晨光制作",
    genre: ["运动", "青春"],
    airTime: "17:30",
    day: "wednesday",
    episode: "第9集",
    desc: "小镇排球部冲向全国大赛，汗水与羁绊交织的青春物语。",
    image: "https://readdy.ai/api/search-image?query=energetic%20stylized%20anime%20artwork%20of%20a%20volleyball%20team%20jumping%20to%20spike%20under%20warm%20sunlight%2C%20coral%20and%20orange%20tones%2C%20youthful%20sport%20scene%2C%20clean%20vector&width=640&height=760&seq=anime-s05&orientation=portrait",
  },
  {
    id: "s06",
    title: "料理次元",
    studio: "味觉动画",
    genre: ["美食", "冒险"],
    airTime: "19:00",
    day: "wednesday",
    episode: "第9集",
    desc: "异世界的厨师少年，用一道道料理打开通往诸国的大门。",
    image: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20anime%20artwork%20of%20a%20young%20chef%20holding%20a%20steaming%20dish%2C%20warm%20coral%20kitchen%20background%2C%20delicious%20food%20fantasy%2C%20clean%20vector&width=640&height=760&seq=anime-s06&orientation=portrait",
  },
  {
    id: "s07",
    title: "机甲纪元",
    studio: "钢铁之心",
    genre: ["机甲", "科幻"],
    airTime: "21:00",
    day: "thursday",
    episode: "第6集",
    desc: "末日之后，人类驾驶机甲守卫最后一座钢铁之城。",
    image: "https://readdy.ai/api/search-image?query=stylized%20anime%20artwork%20of%20a%20giant%20mecha%20robot%20with%20teal%20and%20coral%20accents%20in%20a%20ruined%20city%2C%20epic%20sci-fi%20atmosphere%2C%20clean%20vector&width=640&height=760&seq=anime-s07&orientation=portrait",
  },
  {
    id: "s08",
    title: "樱花银行",
    studio: "春日社",
    genre: ["校园", "恋爱"],
    airTime: "20:30",
    day: "thursday",
    episode: "第6集",
    desc: "樱花树下相遇的两人，在青春银行里存下最珍贵的回忆。",
    image: "https://readdy.ai/api/search-image?query=sweet%20stylized%20anime%20artwork%20of%20two%20school%20students%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20coral%20tones%2C%20romantic%20campus%20scene%2C%20clean%20vector&width=640&height=760&seq=anime-s08&orientation=portrait",
  },
  {
    id: "s09",
    title: "山海食堂",
    studio: "青禾动画",
    genre: ["奇幻", "治愈"],
    airTime: "18:30",
    day: "friday",
    episode: "第5集",
    desc: "老板娘在山海之间开了家小食堂，招待过往的神明与旅人。",
    image: "https://readdy.ai/api/search-image?query=warm%20stylized%20anime%20artwork%20of%20a%20traditional%20mountain%20inn%20with%20steaming%20food%2C%20coral%20lanterns%20and%20misty%20mountains%2C%20healing%20fantasy%20atmosphere%2C%20clean%20vector&width=640&height=760&seq=anime-s09&orientation=portrait",
  },
  {
    id: "s10",
    title: "星际学园",
    studio: "银河制作",
    genre: ["校园", "科幻"],
    airTime: "21:30",
    day: "friday",
    episode: "第5集",
    desc: "银河联盟的星际学园里，一群少年的冒险与成长正悄然上演。",
    image: "https://readdy.ai/api/search-image?query=stylized%20anime%20artwork%20of%20a%20futuristic%20space%20academy%20with%20students%20in%20uniforms%2C%20teal%20and%20coral%20space%20background%2C%20sci-fi%20school%20life%2C%20clean%20vector&width=640&height=760&seq=anime-s10&orientation=portrait",
  },
  {
    id: "s11",
    title: "幻境回声",
    studio: "回声社",
    genre: ["冒险", "悬疑"],
    airTime: "19:30",
    day: "saturday",
    episode: "第4集",
    desc: "能听见幻境回声的少女，在破碎世界里寻找自己的声音。",
    image: "https://readdy.ai/api/search-image?query=mystical%20stylized%20anime%20artwork%20of%20a%20girl%20surrounded%20by%20echoing%20sound%20waves%20in%20a%20dreamy%20landscape%2C%20coral%20and%20teal%20tones%2C%20adventure%20mystery%2C%20clean%20vector&width=640&height=760&seq=anime-s11&orientation=portrait",
  },
  {
    id: "s12",
    title: "喵星特工队",
    studio: "萌宠动画",
    genre: ["搞笑", "动作"],
    airTime: "10:00",
    day: "saturday",
    episode: "第4集",
    desc: "伪装成可爱猫咪的秘密特工队，在欢声笑语中守护城市和平。",
    image: "https://readdy.ai/api/search-image?query=playful%20stylized%20anime%20artwork%20of%20cute%20spy%20cats%20in%20covert%20gear%2C%20warm%20coral%20and%20amber%20tones%2C%20funny%20action%20scene%2C%20clean%20vector&width=640&height=760&seq=anime-s12&orientation=portrait",
  },
  {
    id: "s13",
    title: "云端之森",
    studio: "青柠工作室",
    genre: ["奇幻", "治愈"],
    airTime: "17:00",
    day: "sunday",
    episode: "第3集",
    desc: "漂浮在云端的森林里，守林人守护着世间最温柔的秘密。",
    image: "https://readdy.ai/api/search-image?query=soft%20stylized%20anime%20artwork%20of%20a%20floating%20forest%20island%20in%20the%20sky%2C%20warm%20pastel%20coral%20and%20teal%20tones%2C%20gentle%20healing%20atmosphere%2C%20clean%20vector&width=640&height=760&seq=anime-s13&orientation=portrait",
  },
  {
    id: "s14",
    title: "时光放映室",
    studio: "旧梦社",
    genre: ["剧情", "治愈"],
    airTime: "22:30",
    day: "sunday",
    episode: "第3集",
    desc: "小巷深处的放映室，每一帧胶片都是一段被珍藏的时光。",
    image: "https://readdy.ai/api/search-image?query=nostalgic%20stylized%20anime%20artwork%20of%20a%20cozy%20retro%20cinema%20projection%20room%2C%20warm%20amber%20and%20coral%20glow%2C%20healing%20story%20atmosphere%2C%20clean%20vector&width=640&height=760&seq=anime-s14&orientation=portrait",
  },
];

export const recommendData: AnimeItem[] = [
  scheduleData[0],
  scheduleData[1],
  scheduleData[6],
  scheduleData[8],
  scheduleData[12],
  scheduleData[4],
];

export const updateList: UpdateItem[] = [
  { id: "u01", title: "星穹列车", episode: "更新至第8集", time: "20分钟前", status: "已更新" },
  { id: "u02", title: "剑与铃音", episode: "更新至第8集", time: "1小时前", status: "已更新" },
  { id: "u03", title: "青春排球部", episode: "更新至第9集", time: "2小时前", status: "已更新" },
  { id: "u04", title: "云端邮局", episode: "更新至第7集", time: "3小时前", status: "已更新" },
  { id: "u05", title: "机甲纪元", episode: "更新至第6集", time: "5小时前", status: "已更新" },
  { id: "u06", title: "樱花银行", episode: "更新至第6集", time: "6小时前", status: "已更新" },
  { id: "u07", title: "都市怪谈夜话", episode: "更新至第7集", time: "今天", status: "已更新" },
  { id: "u08", title: "山海食堂", episode: "更新至第5集", time: "今天", status: "已更新" },
];

export const classicList: ClassicItem[] = [
  {
    id: "c01",
    title: "星海守护者",
    year: "2019",
    episodes: "24集",
    score: "9.2",
    tag: "热血",
    desc: "少年们守护星海和平的经典之作，战斗场面燃到极致。",
    image: "https://readdy.ai/api/search-image?query=epic%20stylized%20anime%20artwork%20of%20heroes%20protecting%20a%20galaxy%2C%20warm%20coral%20and%20teal%20tones%2C%20classic%20hot-blooded%20adventure%2C%20clean%20vector&width=640&height=760&seq=classic-c01&orientation=portrait",
  },
  {
    id: "c02",
    title: "春日花房",
    year: "2015",
    episodes: "13集",
    score: "9.0",
    tag: "治愈",
    desc: "花房少女与邻里之间的温暖日常，治愈了无数人的青春。",
    image: "https://readdy.ai/api/search-image?query=gentle%20stylized%20anime%20artwork%20of%20a%20flower%20shop%20girl%20in%20spring%20sunlight%2C%20soft%20pink%20and%20coral%20tones%2C%20healing%20daily%20life%2C%20clean%20vector&width=640&height=760&seq=classic-c02&orientation=portrait",
  },
  {
    id: "c03",
    title: "风之回响",
    year: "2017",
    episodes: "22集",
    score: "9.4",
    tag: "剧情",
    desc: "风之精灵与人族的羁绊传说，剧情细腻、画面唯美。",
    image: "https://readdy.ai/api/search-image?query=ethereal%20stylized%20anime%20artwork%20of%20a%20wind%20spirit%20in%20a%20vast%20meadow%2C%20teal%20and%20coral%20tones%2C%20emotional%20fantasy%2C%20clean%20vector&width=640&height=760&seq=classic-c03&orientation=portrait",
  },
  {
    id: "c04",
    title: "晴空之下",
    year: "2013",
    episodes: "26集",
    score: "8.8",
    tag: "青春",
    desc: "一群少年的飞行梦想与友情，是无数人共同的青春记忆。",
    image: "https://readdy.ai/api/search-image?query=stylized%20anime%20artwork%20of%20youths%20flying%20gliders%20under%20a%20bright%20blue%20sky%20with%20warm%20coral%20sunset%2C%20youthful%20friendship%2C%20clean%20vector&width=640&height=760&seq=classic-c04&orientation=portrait",
  },
];

export const faqList: FaqItem[] = [
  {
    id: "f01",
    question: "51动漫网的新番时间表多久更新一次？",
    answer: "新番时间表会在每季动画开播前整理，并在播出期间根据各平台实际放送情况实时更新，确保你看到的播出时间准确无误。",
  },
  {
    id: "f02",
    question: "如何快速找到自己正在追的动画？",
    answer: "你可以使用页面顶部的搜索框输入动画名称，也可以按星期切换查看每日播出安排。追番推荐板块还会根据热门度为你推荐值得关注的作品。",
  },
  {
    id: "f03",
    question: "追番推荐是基于什么标准挑选的？",
    answer: "追番推荐综合了当季动画的讨论热度、评分、制作团队口碑以及用户的追番反馈，为你筛选出真正值得一看的作品。",
  },
  {
    id: "f04",
    question: "动画更新动态会和播出平台同步吗？",
    answer: "会的。动画更新动态会实时同步热门动画的最新集数信息，方便你第一时间掌握更新进度，不错过每一集。",
  },
  {
    id: "f05",
    question: "经典动画回顾板块有什么特别之处？",
    answer: "经典动画回顾收录了过去数年广受好评的作品，附上评分与简介，方便老观众重温，也方便新观众快速补番。",
  },
  {
    id: "f06",
    question: "使用51动漫网需要注册账号吗？",
    answer: "不需要。51动漫网提供免费的资讯浏览服务，无需注册即可查看完整的新番时间表、追番推荐与动画更新动态。",
  },
];